<script setup lang="ts">
import { getArticleList } from "@carnet/api/backoffice";
import type { ArticleResource } from "@carnet/api/backoffice";

const { data: articles } = await useAsyncData<ArticleResource[]>(
  "articles-news",
  async () => {
    const result = await getArticleList({ composable: "$fetch", path: { locale: appLocale() }, query: { context: "news" } });
    return result ?? [];
  },
  { getCachedData: cachedDataUnlessRefresh, lazy: true }
);
</script>

<template>
  <AppSectionNews :articles="articles ?? []" />
</template>
